var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 49,
    viewBox: "0 0 51 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02264 48.5403C5.02264 48.5403 0.858154 48.5402 0.858154 44.5C0.858154 40.4598 5.02265 28.3391 25.8451 28.3391C46.6675 28.3391 50.832 40.4598 50.832 44.5C50.832 48.5402 46.6675 48.5403 46.6675 48.5403H5.02264ZM25.8451 24.2989C29.1586 24.2989 32.3363 23.0219 34.6793 20.7488C37.0223 18.4757 38.3386 15.3928 38.3386 12.1782C38.3386 8.96358 37.0223 5.88063 34.6793 3.60756C32.3363 1.33449 29.1586 0.0574951 25.8451 0.0574951C22.5316 0.0574951 19.3539 1.33449 17.0109 3.60756C14.6679 5.88063 13.3516 8.96358 13.3516 12.1782C13.3516 15.3928 14.6679 18.4757 17.0109 20.7488C19.3539 23.0219 22.5316 24.2989 25.8451 24.2989Z",
    fill: "#FDBA30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.bea7fe6bad4f6c4472820253edebe7f5.svg";
export { ForwardRef as ReactComponent };